module.exports = __webpack_public_path__ + "static/images/backpack-o.fa37daa.png";